export default __webpack_public_path__ + "static/media/clouds-sm.7f1313ea.png";